
// eslint-disable-next-line import/no-cycle
import { getAdminUserCompany } from '@/api/currencyApi.js'

const company = {
  state: {
    companyList: [],
  },
  mutations: {
    SET_companyList(state, list) {
      state.companyList = list
    },
  },
  actions: {
    GET_companyList({ commit }) {
      return new Promise((resolve, reject) => {
        getAdminUserCompany().then((data) => {
          if (data.code === 1) {
            const companyList = data.data
            resolve(companyList)
            commit('SET_companyList', companyList)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
  },
}

export default company
